
export enum StrandReasonCd {
	LATE_TENDER = 'Late Tender',
	NOT_STRANDED = 'Not Stranded',
	UNDEFINED = 'Undefined',
	XPO_CAUSED = 'XPO Caused'}

